export const LEGACY_MODELS = ['GPT-5.1 Codex', 'GPT-5.1 Codex Max'];

export const NEW_AGENT_DEFAULT_MODEL = 'GPT 5.4 (1M)';

export const NEW_AGENT_MODELS = [
  'GPT-5.1 Codex',
  'GPT-5.1 Codex Max',
  'GPT-5.2 Codex',
  'GPT-5.3 Codex',
  'GPT 5.4',
  'GPT 5.4 (1M)',
  'Chat GPT 5.5',
  'Chat GPT 5.5 (1M)',
  'Claude 4.5 Opus',
  'Claude 4.6 Opus',
  'Claude 4.7 Opus',
  'Claude 4.8 Opus',
];

export const ALL_MODELS = [...new Set([...LEGACY_MODELS, ...NEW_AGENT_MODELS])];

export const REASONING_LEVELS = [
  { value: 'Low', label: 'Low' },
  { value: 'Medium', label: 'Medium' },
  { value: 'High', label: 'High' },
  { value: 'Max', label: 'Max' },
];

export const MODEL_ALIASES: Record<string, string> = {
  'Claude Opus 4.5': 'Claude 4.5 Opus',
  'Claude Opus 4.6': 'Claude 4.6 Opus',
  'GPT 4.5': 'GPT 5.4',
  'GPT 4.5 (1M)': 'GPT 5.4 (1M)',
};
